"use strict";

var _slicedToArray = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var service_1 = __importDefault(require("./service"));

var useController_1 = require("./hooks/useController");

exports.default = function () {
  var _useController_1$useC = useController_1.useController(),
      _useController_1$useC2 = _slicedToArray(_useController_1$useC, 2),
      Controller = _useController_1$useC2[0],
      _useController_1$useC3 = _useController_1$useC2[1],
      read = _useController_1$useC3.read,
      play = _useController_1$useC3.play;

  service_1.default.setup(read, play);
  return Controller;
};